export default {"src":"/_next/static/media/settings.4e69d439.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};